import { useAuth } from '@workos-inc/authkit-react';
import { clearTokenCookie } from './token-cookie';

/**
 * @desc Returns the app's single sign-out action: clears the token cookie, then runs the WorkOS
 * sign-out redirect.
 */
export function useSignOut(): () => void {
  const { signOut } = useAuth();
  return () => {
    clearTokenCookie();
    // Explicit returnTo: the WorkOS default logout URI points at one deployment, which
    // strands sign-outs from every other deployment on the wrong host.
    void signOut({ returnTo: window.location.origin });
  };
}
